import { dashBoardConstants } from '../../_constants/dashBoard.constants';

const initialState = { send_remainder_individual_loading : true, send_remainder_individual: '', send_remainder_individual_error: false};

export function sendRemainderIndividualReducer(state = initialState, action) {
    switch (action.type) {
        case dashBoardConstants.REQUEST_SEND_REMAINDER_INDIVIDUAL:
        return {
            send_remainder_individual_loading: true,
            send_remainder_individual: '',
            send_remainder_individual_error: false
        };
      case dashBoardConstants.RECIEVE_SEND_REMAINDER_INDIVIDUAL:
        return {
            send_remainder_individual_loading: false,
            send_remainder_individual: action.send_remainder_individual,
            send_remainder_individual_error: false
        };
      case dashBoardConstants.ERROR_SEND_REMAINDER_INDIVIDUAL:
        return { 
            send_remainder_individual_loading: false,
            send_remainder_individual: '',
            send_remainder_individual_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/dashBoard/sendRemainderIndividual.reducer.js